import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, } from 'react';
import { MenuItem, makeStyles, Icon, Menu, ListItemIcon, Button, } from '@material-ui/core';
import { useDropdown, } from '../../utils/customHooks';
const useStyle = makeStyles((theme) => {
    return {
        menu: {
            minWidth: '8em',
        },
        languageName: {
            fontSize: '0.875rem',
            textTransform: 'uppercase',
            fontWeight: 500,
            [theme.breakpoints.down('sm')]: {
                display: 'none',
            },
        },
    };
}, {
    name: 'LanguageSelector',
});
/**
 * This is the Language dropdown selector component which can be used any where in the app. To use the component, add this to the
 * template <LanguageSelector />
 * This is a DUMB component. All it does is display the data provided through props. It does not have any logic to change the app's
 * language. The container must handle the onChange event and change the app's language accordingly.
 *
 * This Component is also GENERIC which accept any type of Language object depending on the app that use this component. Each app will have its
 * own Language object structure therefore this Component will not force the container to use a specific Language object type.
 */
export const LanguageSelector = (props) => {
    const [menuAnchorEl, isMenuOpened, onAnchorElClicked, onMenuClosed] = useDropdown();
    const classes = useStyle();
    // Find the selected option
    const selectedOption = useMemo(() => {
        return props.options.find((langOption) => {
            return langOption.selected === true;
        });
    }, [props.options]);
    return (_jsxs("div", { className: props.className || undefined, children: [_jsx(Button, { onClick: onAnchorElClicked, color: "inherit", startIcon: _jsx(Icon, { children: "translate" }), endIcon: _jsx(Icon, { children: "arrow_drop_down" }), children: !props.minimal && _jsx("span", { className: classes.languageName, children: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label }) }), _jsx(Menu, { getContentAnchorEl: null, anchorEl: menuAnchorEl, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'right',
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                }, keepMounted: true, open: isMenuOpened, onClose: onMenuClosed, children: props.options.map((option) => {
                    return (_jsxs(MenuItem, { className: classes.menu, onClick: (event) => {
                            onMenuClosed();
                            if (props.onChange) {
                                props.onChange(event, option.value);
                            }
                        }, selected: option.selected, children: [_jsx(ListItemIcon, { children: _jsx(Icon, { children: option.selected ? 'check' : '' }) }), option.label] }, option.label));
                }) })] }));
};
